import toast from "react-hot-toast";

const BASE = "/api/v1/ads/category-track-mappings";

class CategoryTrackMappingAPIs {
    static async list({ axiosPrivate, app_name, language, category, search, limit = 50, offset = 0 }) {
        try {
            const params = new URLSearchParams({
                ...(app_name && { app_name }),
                ...(language && { language }),
                ...(category && { category }),
                ...(search && { search }),
                ...(limit != null && { limit }),
                ...(offset != null && { offset }),
            });
            const url = `${BASE}/?${params.toString()}`;
            const response = await axiosPrivate.get(url);
            const list = response?.data?.data ?? response?.data ?? [];
            const count = response?.data?.count ?? list?.length ?? 0;
            return { data: Array.isArray(list) ? list : [], count };
        } catch (error) {
            const status = error?.response?.status;
            if (status !== 403 && status !== 401) {
                toast.error(error?.response?.data?.error_message || error?.message);
            }
            return { data: [], count: 0 };
        }
    }

    static async options({ axiosPrivate, app_name, language }) {
        try {
            const params = new URLSearchParams({ ...(app_name && { app_name }), ...(language && { language }) });
            const url = `${BASE}/options/?${params.toString()}`;
            const response = await axiosPrivate.get(url);
            return response?.data?.data ?? { categories: [], tracks_by_category: {} };
        } catch (error) {
            const status = error?.response?.status;
            if (status !== 403 && status !== 401) {
                toast.error(error?.response?.data?.error_message || error?.message);
            }
            return { categories: [], tracks_by_category: {} };
        }
    }

    static async create({ axiosPrivate, payload }) {
        try {
            const response = await axiosPrivate.post(`${BASE}/`, payload);
            return response?.data?.data ?? response?.data;
        } catch (error) {
            toast.error(error?.response?.data?.error_message || error?.message);
            throw error;
        }
    }

    static async update({ axiosPrivate, id, payload }) {
        try {
            const response = await axiosPrivate.patch(`${BASE}/${id}/`, payload);
            return response?.data?.data ?? response?.data;
        } catch (error) {
            toast.error(error?.response?.data?.error_message || error?.message);
            throw error;
        }
    }

    static async remove({ axiosPrivate, id }) {
        try {
            const response = await axiosPrivate.delete(`${BASE}/${id}/`);
            return response?.data?.data ?? response?.data;
        } catch (error) {
            toast.error(error?.response?.data?.error_message || error?.message);
            throw error;
        }
    }

    static async handleSaveCampaigns({ axiosPrivate, id, accounts }) {
        try {
            const response = await axiosPrivate.put(`${BASE}/${id}/campaigns/`, { accounts });
            return response?.data?.data ?? response?.data;
        } catch (error) {
            toast.error(error?.response?.data?.error_message || error?.message);
            throw error;
        }
    }

    static async handleImport({ axiosPrivate, rows, dry_run = true }) {
        try {
            const response = await axiosPrivate.post(`${BASE}/import/`, { rows, dry_run });
            return response?.data?.data ?? response?.data;
        } catch (error) {
            toast.error(error?.response?.data?.error_message || error?.message);
            throw error;
        }
    }
}

export default CategoryTrackMappingAPIs;
